module.exports = __webpack_public_path__ + "static/img/introduceBTypeBIcon11.bf5fcaf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/introduceBTypeBIcon11.png
// module id = BaLO
// module chunks = 0